import React, { useEffect } from "react";
import { Row } from "react-bootstrap";
import "react-image-gallery/styles/css/image-gallery.css";
import "./index.css";
import { Link, useLocation } from "react-router-dom";

const Terms = () => {
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (location.hash) {
        const element = document.getElementById(location.hash.replace("#", ""));
        console.log("Element: ", element);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    }, 500);
  }, [location]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const accountBanner = (
    <div className="terms-banner-main-div text-uppercase desktop">
      <p>
        {" "}
        <Link to={`/`}>{"Home "}</Link>
      </p>
      <h2>{"Terms of Use"}</h2>
    </div>
  );

  return (
    <section className="terms-main-section">
      {accountBanner}
      <div className="terms-conatiner container py-5">
        <Row className="m-0">
          <h2>{"Terms of Use"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h2>

          <p id="terms-section-1">
            {
              "This document is an electronic record in terms of Information Technology Act, 2000 (“IT Act, 2000”), the applicable rules thereunder and the provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures."
            }
            <br />
            <br />

            {
              "This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021 that require publishing the rules and regulations, privacy policy and Terms of Use for access to or usage of www.bharee.com website."
            }
            <br />
            <br />

            {
              "The domain name www.bharee.com , including the related mobile site and mobile application as well as the Seller portal (Seller.bharee.com) (hereinafter referred to as “Platform”) is owned and operated by Bharee Beverages Ecom Pvt. Ltd. (hereinafter referred to as 'bharee'), a company incorporated under the Companies Act, 1956, with its registered office at Bharee Beverages Ecom Pvt. Ltd., Office No-219 & 220 Jai Ganesh Vision Akurdi Pune-411035 Maharashtra India"
            }
            <br />
            <br />

            {
              "For the purpose of the Terms of Use (hereinafter referred to as “ToU”), wherever the context so requires, ‘you’ and ‘your’ shall relate to any natural or legal person who has agreed to become a Seller on the Platform by providing registration data while registering on the Platform using computer systems. The word ‘user’ shall collectively imply a Seller, a Buyer, and any visitor on the Platform and the terms ‘we’, ‘us’ and ‘our’ shall mean Bharee."
            }
            <br />
            <br />

            {
              "Your use of the Platform and the features therein is governed by the following terms and conditions (ToU) including applicable policies available on the Platform, notifications and communications sent to you on the Platform which are incorporated herein by way of reference. If you transact on the Platform, you shall be subject to the policies that are applicable to the Platform for such a transaction. By mere use of the Platform you shall be contracting with Bharee, and these terms and conditions including the policies constitute your binding obligations to Bharee."
            }
            <br />
            <br />

            {
              "When you use any current or future services provided by us through the Platform you will be subject to the rules, guidelines, policies, terms and conditions applicable to such services and they shall be deemed incorporated into the ToU and considered a part and parcel of the ToU. We reserve the right, at our sole discretion, to change, modify, add, or remove portions of the ToU at any time. We will notify you through any of the communication modes as mentioned in this ToU in case of any changes or updates to the ToU that materially impact your use of the Platform. Your continued use of the Platform following the changes or updates will mean that you accept and agree to the revisions. As long as you comply with the ToU, we grant you a personal, non-exclusive, non-transferable, and limited privilege to enter and use the Platform."
            }
            <br />
            <br />

            {"ACCESSING, BROWSING, OR OTHERWISE USING THE PLA"}
          </p>

          <section id="seller-eligibility">
            <h6>{"Seller Eligibility"}</h6>
            <br />
            <p>
              {
                'The use of the Platform is available only to persons who can form legally binding contracts under the Indian Contract Act, 1872. Persons who are "incompetent to contract" within the meaning of the Indian Contract Act, 1872, including minors, un-discharged insolvents etc. are not eligible to use the Platform. If you are a minor i.e. under the age of 18 years, you shall not register as a Seller on the Platform, transact or use the Platform Bharee reserves the right to terminate your registration and/or refuse you access to the Platform if it is brought to Bharee’s notice or discovered that you are under the age of 18 years. If you register as a business entity, you represent that you are duly authorised by the business entity to accept the ToU and you have the authority to bind the business entity to the ToU.'
              }
              <br />
              {"Your Account and Registration Obligations"}
            </p>
            <p>
              {
                "In the course of your use of the Platform, you agree to furnish your details and information as requested by us from time to time including, but not limited to, the following information, to register as a Seller:"
              }
            </p>
            <p>
              <ul>
                <li>{"Seller Complete Name"}</li>
                <li>{"Seller Complete Address"}</li>
                <li>{"Seller Complete Contact details"}</li>
                <li>{"Seller Grievance Officer details for Consumer Complaints"}</li>
                <li>{"Phone no."}</li>
                <li>{"Email Address"}</li>
                <li>{"GSTIN"}</li>
                <li>{"PAN"}</li>
                <li>{"BIS License"}</li>
                <li>{"Fssai License"}</li>
                <li>{"Business Pan"}</li>
                <li>{"Pin code"}</li>
                <li>{"Pick-up Address"}</li>
                <li>
                  {
                    "Registered Address - Principal geographic address of its factory and all warehouse"
                  }
                </li>
                <li>{"Bank A/c Details"}</li>
                <li>{"Account Holder Name"}</li>
                <li>{"Cancelled Cheque"}</li>
                <li>{"Signature"}</li>
                <li>{"Display Legal Name"}</li>
                <li>{"Legal Name / Trade Name"}</li>
                <li>{"Contractual information (SLA)"}</li>
                <li>
                  {
                    "Total price in single figure of any goods / service (break up price / charges, if any)"
                  }
                </li>
                <li>
                  {
                    "Relevant details of goods including Manufacturer / Packer / Name and Complete Address"
                  }
                </li>
                <li>
                  {
                    "Relevant product shelf life or warranties applicable to a            ll goods / services you are selling on the platform"
                  }
                </li>
              </ul>
            </p>
            <p>
              {
                "You agree that you have necessary licences and permits for the sale on the Platform which shall be including but not limited to the licences required by all applicable laws."
              }
            </p>
            <p>
              {
                "You shall remain responsible for maintaining confidentiality of this information, as well as your display name, login and password details. You agree that if you provide any information which is untrue, inaccurate, not current, or incomplete or we have reasonable grounds to suspect that such information is untrue, inaccurate, not current, incomplete, or not in accordance with the ToU, we shall have the right to suspend or terminate your account on the Platform or indefinitely block you from accessing the Platform."
              }
            </p>
          </section>

          <section id="seller-account-deactivation">
            <h6>{"Seller Account Deactivation"}</h6>
            <br />
            <p>
              {
                "As per our policy, if a Seller requests for a closure of the account, the account will be put on hold for a period of 90 days to ensure smooth closure of transactions which have been made prior to his closure request and this will be available to the said Seller for downloading payment and taxation reports, if required. After 90 days, the Seller would be required to reach out to us confirming that he has downloaded the reports and requesting for a deactivation again. Upon receiving this confirmation, the Seller’s account will be deactivated provided there are no outstanding payments due from the Seller, with certain information being retained by Bharee at all times, such as registered mobile number, registered email ID, GSTIN and other transaction related information. Such information is being retained for audit purposes and to prevent fraudulent acts by the Sellers in the future. If a Seller decides to commence his business with Bharee again, he/she will not be able to create a new account but the older account can be restored if it is required."
              }
            </p>
          </section>

          <section id="communications">
            <h6>{"Communications"}</h6>
            <br />
            <p>
              {
                "When you use the Platform or send emails, other data, information, or communication to us, you agree and understand that you are communicating with us through electronic records and you consent to receive communications via electronic records from us periodically or as and when required. We may communicate with you by email or any other mode of communication, electronic or otherwise."
              }
              <br />
              {"Platform for Transaction and Communication"}
              <br />
              {
                "The Platform is a platform that users utilise to independently meet and interact with one another for their transactions. Bharee is not and cannot be a party to any transaction or dispute between users on the Platform."
              }
            </p>
          </section>

          <section id="consequently">
            <h6>{"Consequently"}</h6>
            <br />
            <p>
              <ol>
                <li>
                  {
                    "All commercial / contractual terms are offered by you and agreed upon between you and Buyers alone. The commercial / contractual terms include (without limitation) price, shipping costs, payment methods, credits and terms, date, period, and mode of delivery, and warranties and after-sales services related to products and services. Bharee does not determine, advise, have any control, or in any way involve itself in the offering or acceptance of such commercial / contractual terms between you and Buyers."
                  }
                </li>
                <li>
                  {
                    "Bharee does not make any representations or warranties regarding specifics (such as quality, value, and saleability) of the products or services proposed to be sold, offered to be sold or purchased on the Platform. Bharee does not implicitly or explicitly support or endorse the sale or purchase of any products and services on the Platform. Bharee accepts no liability for any errors or omissions of third parties in relation to the products and services."
                  }
                </li>
                <li>
                  {
                    "Bharee is not responsible for any non-performance or breach of any contract between you and buyers. Bharee cannot and does not guarantee that you and Buyers concerned will perform transaction(s) concluded on the Platform. Bharee shall not and is not required to mediate or resolve disputes or disagreements between you and Buyers"
                  }
                </li>
                <li>
                  {
                    "Bharee does not make any representations or warranties regarding item-specifics (such as legal title, creditworthiness, identity, etc.) of any of its users. You are advised to independently verify the bona fides of any particular Buyer you choose to deal with on the Platform and use your best judgement in that regard."
                  }
                </li>
                <li>
                  {
                    "Bharee does not at any point in time during a transaction between you and a Buyer on the Platform come into or take possession of any of the products or services offered by you, gain title to or have any rights or claims over the products or services offered by you to the Buyer."
                  }
                </li>
                <li>
                  {
                    "At no time shall Bharee hold any right / title to or interest in the items nor have any obligations or liabilities with respect to such a contract. Bharee is not responsible for unsatisfactory or delayed performance of services, damages, or delays as a result of items which are out of stock, unavailable, or back-ordered"
                  }
                </li>
                <li>
                  {
                    "The Platform is only a platform that can be utilised by you to reach a larger Customer base to sell items or services. Bharee only provides a platform for communication and it is agreed that the contract for sale of any products or services shall be a strictly bipartite contract between you and the Buyer."
                  }
                </li>
                <li>
                  {
                    "You release and indemnify Bharee and / or any of its officers and representatives from any cost, damage, liability or other consequence of any of the actions of the users on the Platform and specifically waive any claims that you may have in this behalf under any applicable law. Notwithstanding its reasonable efforts on that behalf, Bharee cannot control the information provided by other users which is made available on the Platform. You may find other user's information to be offensive, harmful, inaccurate or deceptive. Please use caution and practise safe trading when using the Platform. Please note that there may be risks in dealing with underage persons or people acting under false pretence."
                  }
                </li>
              </ol>
            </p>
          </section>

          <section id="use-of-the-platform">
            <h6>{"Use of the Platform"}</h6>
            <br />
            <p>
              {
                "You agree and understand that Bharee and the Platform merely provide hosting services to its registered users and persons browsing / visiting the Platform. All items advertised / listed and the contents therein are advertised and listed by registered users and are third party user generated contents. Bharee shall bear no responsibility or liability in relation to or arising out of third party user generated content. Bharee neither originates nor initiates the transmission nor selects the sender and receiver of the transmission nor selects nor modifies the information contained in the transmission. Bharee is merely an intermediary and does not interfere in the transaction between Buyers and Sellers."
              }
            </p>
            <br />
            <p>
              {
                "You agree, undertake and confirm that your use of the Platform shall be strictly governed by the following binding principles:"
              }
            </p>

            <p>
              {
                "You shall not host, display, upload, modify, publish, transmit, update or share any information or image which:"
              }{" "}
              <br />
              <ol>
                <li>{"belongs to another person and over which you have no right;"}</li>
                <li>
                  {
                    "is grossly harmful, harassing, blasphemous, defamatory, bigotry, obscene, pornographic, paedophilic, libellous, invasive of another’s privacy, hateful, or racially, ethnically objectionable, disparaging, relating to or encouraging money laundering or gambling, or otherwise unlawful in any manner whatever, or unlawfully threatening or harassing, including but not limited to ‘indecent representation of women’ within the meaning of the Indecent Representation of Women (Prohibition) Act, 1986;"
                  }
                </li>
                <li>{"is false, inaccurate or misleading in any way;"}</li>
                <li>
                  {
                    "is patently offensive to the online community, such as sexually explicit content or content that promotes obscenity, pedophilia, racism, bigotry, hatred, or physical harm of any kind against any group or individual;"
                  }
                </li>
                <li>{"harasses or advocates harassment of another person;"}</li>
                <li>
                  {
                    "involves the transmission of ‘junk mail’, ‘chain letters’, unsolicited mass mailing, or ‘spamming’; including spamming by ways of unrelated feedbacks on surveys"
                  }
                </li>
                <li>
                  {
                    "promotes illegal activity or conduct that is abusive, threatening, obscene, defamatory, or libellous;"
                  }
                </li>
                <li>
                  {
                    "infringes upon or violates any third party's rights [including but not limited to intellectual property rights, rights of privacy (including without limitation unauthorised disclosure of a person's name, email address, physical address, or phone number) or rights of publicity];"
                  }
                </li>
                <li>
                  {
                    "promotes an illegal or unauthorised copy of another person's copyrighted work (see “Copyright complaint\" below for instructions on how to lodge a complaint about uploaded copyrighted material) such as providing pirated computer programs or links, information to circumvent manufacturer-installed copy-protect devices, or pirated music or links to pirated music files;"
                  }
                </li>
                <li>
                  {
                    "contains restricted or password-only access pages, hidden pages or images or URLs leading to any other pages (those not linked to or from another accessible page);"
                  }
                </li>
                <li>
                  {
                    "provides material that exploits people in a sexual, violent or otherwise inappropriate manner or solicits personal information from anyone;"
                  }
                </li>
                <li>
                  {
                    "provides instructional information about illegal activities such as making or buying illegal weapons, violating someone's privacy, providing or creating computer viruses;"
                  }
                </li>
                <li>
                  {
                    "contains unauthorised videos, photographs or images of another person (whether a minor or an adult);"
                  }
                </li>
                <li>
                  {
                    "tries to gain unauthorised access or exceeds the scope of authorised access to the Platform, profiles, blogs, communities, account information, bulletins, friend requests, or other areas of the Platform, or solicits passwords or personal identifying information for commercial or unlawful purposes from other users on the Platform;"
                  }
                </li>
                <li>
                  {
                    "engages in commercial activities and / or sales such as contests, sweepstakes, barter, advertising, pyramid schemes, or the buying or selling of ‘virtual’ items related to the Platform without our prior written consent."
                  }
                </li>
                <li>
                  {
                    "Throughout the ToU, Bharee’s prior written consent means a communication coming from Bharee’s Legal Department in response to your request and specifically addressing the activities or conduct for which you have sought authorization;"
                  }
                </li>
                <li>
                  {
                    "solicits gambling or engages in any gambling activity which we, at our sole discretion, believe is or could be construed as being illegal;"
                  }
                </li>
                <li>{"interferes with another’s use and enjoyment of the Platform;"}</li>
                <li>
                  {
                    "refers to any website / URL which, at our sole discretion, contains material that is inappropriate for the Platform or any other website and content that is prohibited or violates the letter and spirit of ToU;"
                  }
                </li>
                <li>{"harms minors in any way;"}</li>
                <li>
                  {
                    "infringes any patent, trademark, copyright, proprietary rights, third-party’s trade secrets, rights of publicity, or privacy, is fraudulent, or involves the sale of counterfeit or stolen items"
                  }
                </li>
                <li>{"violates any law for the time being in force;"}</li>
                <li>
                  {
                    "deceives or misleads the addressee / users about the origin of messages or communicates any information which is grossly offensive or menacing in nature;"
                  }
                </li>
                <li>{"impersonates another person;"}</li>
                <li>
                  {
                    "contains software viruses or any other computer codes, files, or programs designed to interrupt, destroy, or limit the functionality of any computer resource; or contains any trojan horses, worms, time bombs, cancelbots, easter eggs, or other computer programming routines that may damage, detrimentally interfere with, diminish value of, surreptitiously intercept, or expropriate any system, data, or personal information;"
                  }
                </li>
                <li>
                  {
                    "threatens the unity, integrity, defence, security or sovereignty of India, friendly relations with foreign states, or public order or causes incitement to the commission of any offence or prevents investigation of any offence or is insulting any other nation; offends the religious and national sentiments of the nation as included in ‘Zero Tolerance to Profanity, Hurting National and Religious Sentiments’ policy."
                  }
                </li>
                <li>
                  {
                    "shall, directly or indirectly, offer or attempt to offer trade or attempt to trade in any item which is prohibited or restricted in any manner under the provisions of any applicable law, rule, regulation or guideline for the time being in force"
                  }
                </li>
                <li>
                  {
                    "shall create liability for us or cause us to lose (in whole or part) the services of our Internet Service Provider (“ISPs”) or other suppliers."
                  }
                </li>
                <li>
                  {
                    "You shall not use any ‘deep-link’, ‘page-scrape’, ‘robot’, ‘spider’, automatic device, program, algorithm, methodology, or any similar or equivalent manual process to access, acquire, copy, monitor any portion of the Platform or content or in any way reproduce, or circumvent the navigational structure, presentation of the Platform, or any content to obtain or attempt to obtain any material, documents, or information through any means not purposely made available through the Platform. We reserve our right to bar any such activities."
                  }
                </li>
                <li>
                  {
                    "You shall not attempt to gain unauthorised access to any portion or feature of the Platform, other systems, networks connected to the Platform, server, computer, network, or the services offered on or through the Platform by hacking, password ‘mining’, or any other illegitimate means"
                  }
                </li>
                <li>
                  {
                    "You shall not probe, scan or test the vulnerability of the Platform or any network connected to the Platform or breach the security, authentication measures on the Platform or any network connected to the Platform. You may not reverse look-up, trace or seek to trace information on any other user of or visitor to Platform (including any account on the Platform that is not owned by you) or to its source or exploit the Platform, any service, information made available, or offered by or through the Platform in any way where the purpose is to reveal any information (including but not limited to personal identification or information other than your own information) provided by the Platform."
                  }
                </li>
                <li>
                  {
                    "You shall not make any negative, denigrating, or defamatory statement(s) / comment(s) about us, the brand name or domain name used by us, including Bharee, Bharee affiliates and associated entities, or otherwise engage in any conduct or action that might tarnish the image or reputation of Bharee or Sellers on the platform or otherwise tarnish or dilute any Bharee trademark, service marks, trade name and / or goodwill associated with such trade, service marks or trade name as may be owned or used by us. You agree that you will not take any action that imposes an unreasonable or disproportionately large load on the infrastructure of the Platform or Bharee’s systems, networks, or any systems or networks connected to Bharee."
                  }
                </li>
                <li>
                  {
                    "You agree not to use any device, software or routine to interfere or attempt to interfere with the proper working of the Platform, any transaction being conducted on the Platform or any other person’s use of the Platform."
                  }
                </li>
                <li>
                  {
                    "You shall not forge headers or otherwise manipulate identifiers in order to disguise the origin of any message, transmittal you send to us on or through the Platform, or any service offered on or through the Platform. You may not pretend that you are or represent someone else or impersonate any other individual or entity."
                  }
                </li>
                <li>
                  {
                    "You may not use the Platform or any content for any purpose that is unlawful or prohibited by the ToU or to solicit the performance of any illegal activity or other activity which infringes the rights of Bharee and / or others."
                  }
                </li>
                <li>
                  {
                    "You shall at all times ensure full compliance with the applicable provisions of the Information Technology Act, 2000, and the other rules thereunder as applicable and amended from time to time and also all applicable domestic laws, rules and regulations (including the provisions of any applicable Exchange Control Laws or Regulations in force) and International Laws, Foreign Exchange Laws, Statutes, Ordinances and Regulations (including, but not limited to Integrated Goods and Services Tax Act, Central Goods and Services Tax Act, Food Safety and Standards Authority of India (FSSAI),Bureau of Indian Standard(BIS), relevant State Goods and Services Tax Act or Union Territories Goods and Services Tax Act and Custom Duty, Local Levies as may be applicable) and obtain the necessary licences and permits regarding your use of our Platform, service and / or tools and your listing, purchase, solicitation of offers to purchase, and sale of items or services. You shall not engage in any transaction in an item or service, which is prohibited by the provisions of any applicable law including exchange control laws or regulations for the time being in force."
                  }
                </li>
                <li>
                  {
                    "Solely to enable us to use the information you provide us with and so that we do not violate any rights you might have in your information, you agree to grant us a non-exclusive, worldwide, perpetual, irrevocable, royalty-free, and sub-licensable (through multiple-tiers) right to exercise the copyright, publicity or database rights or any other rights you have in your information for any current or future promotional or advertising related activities and any business purposes of Bharee."
                  }
                </li>
                <li>
                  {
                    "3From time to time you shall be responsible for providing information relating to the items or services proposed to be sold by you. In this connection, you undertake that all such information shall be accurate in all respects. You shall not exaggerate or over emphasise the attributes of such items or services so as to mislead other users on the Platform in any manner."
                  }
                </li>
                <li>
                  {
                    "You shall not engage in advertising or solicitation of other Sellers on the Platform to buy or sell any products or services, including but not limited to products or services related to what is displayed on the Platform. You may not transmit any chain letters or unsolicited commercial or junk email to other users acquired / via the Platform. It shall be a violation of the ToU to use any information obtained from the Platform in order to harass, abuse, or harm others or contact, advertise and sell to or solicit persons other than those who have chosen to buy from you. You understand that we have the right at all times to disclose any information (including the identity of the persons who have provided information or material on the Platform) as necessary to satisfy any law, regulation, or valid governmental request. This may include, without limitation, disclosure of the information in connection with the investigation of an alleged illegal activity or its solicitation and / or response to a lawful court order or subpoena. In addition, we can (and you hereby expressly authorise us to) disclose any information about you to law enforcement or other government officials as we, at our sole discretion, deem necessary or appropriate in connection with the investigation and / or resolution of possible crimes, especially those that may involve personal injury. We reserve the right, but have no obligation, to monitor the material posted on the Platform. Bharee shall have the right, at its sole discretion, to remove any content that violates or is alleged to violate any applicable law or either the spirit or letter of the ToU. Notwithstanding this right, YOU REMAIN SOLELY RESPONSIBLE FOR THE CONTENT OF THE MATERIAL YOU POST ON THE WEBSITE AND YOUR INDEPENDENT COMMUNICATION WITH THE BUYERS AND OTHER SELLERS, REGARDLESS OF FORM. Please be advised that such content posted does not reflect Bharee’s views. In no event shall Bharee assume or have any responsibility or liability for any content posted on the Platform or claims, damages, or losses resulting from its use and / or appearance of it on the Platform. You hereby represent and warrant that you have necessary rights to all the content you provide and all information it contains and that such content shall not infringe any proprietary or other rights of third parties or contain any misleading, libellous, tortious, or otherwise unlawful information."
                  }
                </li>
                <li>
                  {
                    "Your correspondence or business dealings with or participation in the promotion of advertisers on or through the Platform (including payment and delivery of related products or services, any other terms, conditions, warranties, or representations associated with such dealings) are solely between you and such advertisers. We shall not be responsible or liable for any loss or damage of any sort incurred as a result of such dealings or the presence of such advertisers on the Platform."
                  }
                </li>
                <li>
                  {
                    "It is possible that other users (including unauthorised persons or ‘hackers’) may post or transmit offensive or obscene material on the Platform and that you may be involuntarily exposed to such material. It is also possible for others to obtain personal information about you due to your use of the Platform and use such information to harass or injure you. We do not approve of such unauthorised uses but by using the Platform, you acknowledge and agree that we are not responsible for the use of any personal information that you publicly disclose or share with others on the Platform. Please carefully select the type of information that you publicly disclose or share with others on the Platform."
                  }
                </li>
                <li>
                  {
                    "Bharee shall have all the rights to take necessary action and claim damages that may occur due to your involvement / participation in any way on your own or through group(s) of people, intentionally or unintentionally, in DoS (denial of service) / DDoS (Distributed Denial of Services)."
                  }
                </li>
                <li>
                  {
                    "Bharee and / or its affiliates may from time to time in partnership / association with its partners and / or third-party sponsors, organise / enable promotional campaigns on the Platform for the benefits of the Customers / Sellers. Partners / third party sponsors may prescribe certain objective qualifying criteria to identify Sellers who will be eligible for the benefits of the campaign. All Sellers who qualify based on the objective criteria provided by such sponsors of the campaign will be auto opted-in and be able to obtain the benefits of such promotional campaigns. In the event any Seller does not qualify based on the objective criteria, Sellers may choose to participate in such campaigns by expressly opting-in for them. In the event a Seller opts in for such promotional campaigns that they are not eligible for to enhance their sales, they will have to bear the cost of such promotional campaigns, if any, limited to the sales of their products. For avoidance of any doubt, some Sellers may qualify, and some may not, based on the qualifying criteria set for each individual campaign. Please refer to the campaign communication / notifications for more details, as may be communicated to you from time to time."
                  }
                </li>
                <li>
                  {
                    "You shall strictly comply with all the policies shared by Bharee for ethical working and shall not form any form of cartel or similar arrangement to influence the price or sale on the platform in any form or manner whatsoever."
                  }
                </li>
                <li>
                  {
                    "You shall ensure that the personal data of customers is used only for the purpose of scope of customisation transaction and as per the authorisation received from Bharee/Customer. The personal data shared with the seller should be kept confidential and secure and should be deleted post the warranty period. The seller shall not use the customer data for any unauthorised purpose."
                  }
                </li>
                <li>
                  {
                    "This ToU and its Annexures constitutes the entire agreement between the Parties pertaining to the subject matter contained herein and supersedes and cancels in all respects all other agreements and understandings of the Parties, whether oral or written, pertaining to the subject matter under this ToU. The terms of this ToU may be modified, amended, varied or waived as per the requirements of Bharee."
                  }
                </li>
              </ol>
            </p>
          </section>

          <section id="selling">
            <h6>{"Selling"}</h6>
            <br />
            <p>
              {
                "As a registered Seller, you shall list item(s) for sale on the Platform in accordance with the policies which are incorporated by way of reference in this ToU. You must be legally able to sell the item(s) you list for sale on our Platform and must have all the necessary licences and permits required for such sale. You must ensure that the listed items do not infringe upon the intellectual property, trade secret or other proprietary rights or rights of publicity or privacy rights of third parties. Listings may only include text descriptions, graphics, pictures or videos that describe your item for sale. All items must be listed in an appropriate category on the Platform. All listed items must be kept in stock for successful fulfilment of sales. The listing description of the item must not be misleading and must describe the actual condition of the product. If the item description does not match the actual condition of the item, you agree to refund any amount that you may have received from the Buyer. You agree not to list a single product in multiple quantities across various categories on the Platform.Bharee reserves the right to delete such multiple listings of the same product listed by you in various categories. Bharee reserves the right to restrict the selling of products originating from certain countries."
              }
            </p>
            <br />
            <p>
              {
                "For Food and Nutrition category, Seller shall adhere to the minimum balance shelf life norms as provided in FSSAI E-Commerce regulations and timely amendment thereof."
              }
            </p>
          </section>

          <section id="compliance-selling">
            <h6>{"Compliance on selling of Goods / Services"}</h6>
            <br />

            <p>
              {
                "You shall also ensure full compliance with the provisions of Integrated Goods and Services Tax (IGST), Central Goods and Services Tax (CGST) and Union Territory Goods and Services Tax (UTGST) or State Goods and Services Tax (SGST) in respect of the Goods / Services supplied by you."
              }
            </p>

            <p>
              {
                "It is your responsibility to charge appropriate Goods and Services taxes on the supplies affected and remittance of the same to the Government. Bharee shall not be responsible for any deficiency and / or omission on your part."
              }
            </p>

            <p>
              {
                "Pursuant to the tax collection at source provisions under IGST, CGST and / UTGST or SGST, the portal would collect tax collection at source at applicable rates on net value of taxable supplies made through the portal and remit to the appropriate Government."
              }
            </p>

            <p>
              {
                "In case of any mismatches on account of tax collection at source, you shall be required to provide all relevant information to Bharee to correspond with the relevant authorities and also in case of any liability accruing on account of omission shall be your obligation to pay such deficit."
              }
            </p>

            <p>
              {
                "You shall be required to provide the corresponding Harmonised System Nomenclature (HSN) code number for every product listing. In the event that you do not provide the HSN code number that particular product will be delisted and you will no longer be able to sell the product on our platform."
              }
            </p>

            <p>
              {
                "You shall also be required to provide your GSTIN, without which we will not be able to raise an invoice on you. In the event that you do not provide your GSTIN number, transactions on your account will be blocked and orders will not be processed on your account. In the event of you providing your Input Service Distributor."
              }
            </p>

            <p>
              {
                "Registration Number, Bharee would be issuing an invoice to the ISD GST registration number as furnished by you. It is your responsibility to undertake the necessary compliance required in respect of the said ISD registration number."
              }
            </p>
          </section>

          <section id="income-tax">
            <h6>{"Income-tax"}</h6>
            <br />
            <p>
              <ul>
                <li>
                  {
                    "Bharee would withhold taxes as applicable under the Income-tax Act, 1961. Currently, Bharee is liable to withhold taxes under section 194-O of the Income-tax Act, 1961 at the applicable rate on sale of goods or provisions of services facilitated on the Platform. Accordingly, the portal would make the payment in respect for sale of goods or provisions of services facilitated through the portal after deducting the applicable taxes"
                  }
                </li>
                <li>
                  {
                    "Where you provide Nil/Lower deduction tax certificate issued under Section 197 of the Income-tax Act, 1961 (‘LDC’), to Bharee, it would deduct/collect taxes at the rates specified in the said certificates. In case, if the said LDCs are modified by the Income-tax Officer subsequently, you are responsible to inform Bharee and any liability arising on account of omission, shall be your obligation."
                  }
                </li>
                <li>
                  {
                    "Bharee will withhold taxes at higher rates as applicable under Section 206AA and Section 206AB of the Income-tax Act, 1961 in case warranted."
                  }
                </li>
                <li>
                  {
                    "Bharee agrees to furnish Form 16A to you within prescribed timelines as per the Income-tax Act, 1961."
                  }
                </li>
                <li>
                  {
                    "You are responsible to collect applicable taxes (‘TCS’) under provisions of Chapter XVII BB of the Income-tax Act, 1961 on sales made or provision of services to buyers and to ensure the requisite compliances in this regard. Bharee will not be liable for any withholding tax or other compliances that will be applicable to the buyer/you in that capacity."
                  }
                </li>
              </ul>
            </p>
            <p>
              {
                "In the event of any conflict between the terms of this clause and any other clause in these terms of use, the provisions of this clause will prevail."
              }
            </p>
            <p>
              {
                "You agree and undertake that You shall not, at any time, purchase more than 25% of your inventory (in terms of annualised value in a financial year), purported to be sold on the Platform, from Bharee or its Group Companies. Group Company shall have the meaning as per the extant Foreign Direct Investment Policy of India. We may require you to provide certification (including auditors certificate) to confirm compliance with this requirement"
              }
            </p>
            <p>
              {
                "We do not mandate that any of your Products should be sold exclusively on the Platform. For the sake of clarity, effective February 01, 2019, Bharee unilaterally waives any obligation on You to sell exclusively on the Platform. Any written or oral arrangements to the contrary, shall stand unilaterally waived."
              }
            </p>
            <p>
              {
                "As per Section 194-O of the Finance Act, 2020, Bharee will deduct TDS on the gross amount of sale (excluding GST) of goods or provision of services provided through the Platform at 0.75% from October 1, 2020 to March 31, 2021 and at 1% thereafter."
              }
            </p>
          </section>

          <section id="content-posted-on-platform">
            <h6>{"Content Posted on the Platform"}</h6>
            <br />
            <p>
              {
                "All text, graphics, Seller interfaces, visual interfaces, photographs, trademarks, logos, sounds, music and artwork, notes, messages, emails, billboard postings, drawings, profiles, opinions, ideas, images, videos, audio files, other material or information (collectively ‘Content’) are third-party generated Content and Bharee has no responsibility or liability over such third-party generated Content as Bharee is merely an intermediary for the purposes of this ToU. Except as expressly provided in the ToU, no part of the Platform including the Content may be copied, reproduced, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted or distributed in any way (including ‘mirroring’) to any other computer, server, website or other medium for publication, distribution or any commercial enterprise without Bharee’s prior written consent"
              }
            </p>
            <br />
            <p>
              {
                "You may use the information on the products and services made available on the Platform for downloading provided you:"
              }
              <ol>
                <li>
                  {"do not remove any proprietary notice language in all copies of such Content;"}
                </li>
                <li>
                  {
                    "use such Content only for your personal, non-commercial informational purpose and do not copy or post such information on any networked computer or broadcast it to any media;"
                  }
                </li>
                <li>{"make no modifications to any Content; and"}</li>
                <li>
                  {
                    "do not make any additional representations or warranties relating to the Content."
                  }
                </li>
              </ol>
            </p>
            <p>
              {
                "You shall be responsible for the Content posted or transmitted on the Platform by You. The Content will become our property and you grant us the worldwide, perpetual, royalty free and transferable rights in such content. We shall be entitled to, consistent with our privacy policy as adopted in accordance with applicable law, use the Content or any of its elements for any type of purpose forever, including, but not limited to, promotional and advertising purposes in any media, whether now known or hereafter devised or the creation of derivative work. You agree that any content you post may be used by us, consistent with this ToU, and you are not entitled to any payment or other compensation for such use"
              }
            </p>
          </section>

          <section id="limited-license">
            <h6>{"Limited Licence"}</h6>
            <br />
            <p>
              {
                "Bharee grants Sellers a limited, non-transferable, non-exclusive, non-sub licensable, non-assignable and personal licence to use “Bharee.com” name and / or logo on Seller’s invoice for transactions concluded on the Platform. Further, Bharee grants Sellers a limited, non-transferable, non-exclusive, non-sublicensable, non-assignable and personal licence to use “Bharee.com” name and / or logo on packing material used by Sellers for delivery of Products sold on the Platform."
              }
            </p>
          </section>

          <section id="type-of-sellers">
            <h6>{"Types of Sellers"}</h6>
            <br />
            <p>
              {"All registered Sellers are categorised basis the following criteria:"}
              <ul>
                <li>{"Sales achieved by Sellers (revenues and units)"}</li>
                <li>
                  {"Fulfilment experience provided to Customers (breaches and cancellations)"}
                </li>
                <li>{"Percentage of local / zonal shipment out of your overall shipment"}</li>
                <li>
                  {
                    "Percentage of overall shipments supplied in the same zone to Customers by the Seller"
                  }
                </li>
                <li>
                  {
                    "Customer feedback against the products sold by such Sellers (returns and ratings), etc."
                  }
                </li>
                <li>
                  {
                    "The thresholds for each of these criteria are transparently listed on www.bharee.com. Basis the categorization / tier, Sellers get benefits including the following:"
                  }
                </li>
                <li>{"Reduced rate card for the shipping fees"}</li>
                <li>{"Account management support"}</li>
                <li>{"Faster payments"}</li>
              </ul>
            </p>
            <p>
              {
                "Bharee reserves the right to revise the categories, criteria, and benefits to promote healthy competition amongst the Sellers so that their performance leads to better Customer experience on the Platform"
              }
            </p>
          </section>

          <section id="payment">
            <h6>{"Payment"}</h6>
            <br />
            <p>
              <ol>
                <li>
                  {
                    "Transactions, transaction price and all commercial terms such as delivery, dispatch of products and / or services are as per principal to principal bipartite contractual obligations between Sellers and Buyers and the payment facility is merely used by Sellers and Buyers to facilitate the completion of transactions. Use of the payment facility shall not render Bharee liable or responsible for non–delivery, non-receipt, non-payment, damage, breach of representations and warranties, non-provision of after-sales or warranty services or fraud as regards the products and/or services listed on the Platform."
                  }
                </li>
                <li>
                  {
                    "You have specifically authorised Bharee or its service providers to collect, process, facilitate, and remit payments and / or the transaction price electronically or through pay on delivery (PoD) to and from Buyers in respect of transactions through payment facility. Your relationship with Bharee is on a principal to principal basis and by accepting the ToU, you agree that Bharee is an independent contractor for all purposes and does not have control of or liability for the products or services that are listed on the Platform and paid for by using the payment facility. Bharee does not guarantee the identity of any User nor does it ensure that a Buyer or a Seller will complete a transaction."
                  }
                </li>
                <li>
                  {
                    "You understand, accept, and agree that the payment facility provided by Bharee is neither a banking nor financial service, but merely a facilitator providing an electronic, automated online electronic payment facility for receiving payment, or pay on delivery (PoD) payment, collection and remittance for transactions on the Platform using the existing authorised banking infrastructure and credit card payment gateway (PG) network. Further, by providing payment facility, Bharee neither acts as a trustee or fiduciary with respect to transaction or transaction price."
                  }
                  <span>
                    {
                      " It is hereby clarified that pay on delivery (POD) and pay later (PL) option may not be available for select products or categories, at Bharee’s sole discretion."
                    }
                  </span>
                </li>
                <li>
                  {
                    "All online bank transfers from valid bank accounts are processed using the gateway provided by the respective issuing bank that supports payment facility to provide these services to the users. All such online bank transfers on payment facility are also governed by the terms and conditions agreed to between a Seller, Buyer and the respective issuing bank."
                  }
                </li>
              </ol>
            </p>
          </section>

          <section id="dispatch-of-products">
            <h6>{"Dispatch of products and / or services"}</h6>
            <br />
            <p>
              <ol>
                <li>
                  {
                    "You, as a Seller, shall be required to dispatch the products and / or services for every transaction to the Buyer within the time period as provided in the ToU to ensure that the products and / or services are delivered in a timely manner. Further, you will solely be responsible for undertaking transit insurance for products sold by You on the Platform. For avoidance of doubt, Bharee will not be responsible for undertaking any insurance(s) for products sold by Sellers on the Platform."
                  }
                </li>
                <li>
                  {
                    "Seller shall provide dispatch details and details of after-sales services related to products and services listed by it on the Platform to Bharee in such a manner and within a time period as provided in the policies, failing which the transaction shall stand cancelled"
                  }
                </li>
                <li>
                  {
                    "Seller shall dispatch the products and / or services using only an approved delivery channel which provides appropriate ‘proof of dispatch’ & ‘proof of delivery’ (PoDs) documentation. Such PoD documentation relating to delivery should be maintained by a Seller for a period of 3 (three) years from the date of dispatch. The PoDs should be furnished to Bharee on demand within the time frame as notified from time to time."
                  }
                </li>
                <li>
                  {
                    "Seller agrees that the dispatch details shall be true, correct, and duly authorised and shall not be misleading, fraudulent, false, unauthorised, illegal and shall not contain any misrepresentation of facts."
                  }
                </li>
                <li>
                  {
                    "In case a Seller fails to provide dispatch details or provides dispatch details not complying with policies, it shall result in consequences as more specifically stated in the ToU and may lead to suspension and / or termination of Seller account."
                  }
                </li>
                <li>
                  {
                    "Seller agrees that the transaction price paid by a Buyer will be remitted to a Seller’s bank account contingent upon the following events:"
                  }
                  <br />
                  <ul>
                    <li>
                      {
                        "Buyer confirms the delivery of products and / or services in the transaction;"
                      }
                    </li>
                    <li>
                      {
                        "Buyer does not take any action on payment facility to confirm delivery within such a time period as provided in the policies despite confirmation of dispatch of products and / or services by a Seller to the Buyer;"
                      }
                    </li>
                    <li>
                      {
                        "Buyer’s refund claim is rejected by Bharee due to any breach of the ToU, policies, and any applicable law;"
                      }
                    </li>
                    <li>
                      {
                        "Once the transaction is completed by the Seller, the remittance to Seller shall be made in accordance with RBI Intermediary Guidelines."
                      }
                    </li>
                  </ul>
                </li>
                <li>
                  {
                    "You are required to route all shipments / consignments through the Logistic Partner, unless otherwise specified. ‘Logistic Partner’ shall mean a logistic service provider as approved by Bharee."
                  }
                </li>
              </ol>
            </p>
          </section>

          <section id="seller-delivery-policies">
            <h6>Seller Delivery Policy and Penalties</h6>
            <br />
            <p>
              This policy outlines the terms and consequences for sellers regarding delivery
              commitments on the Bharee platform.
              <br />
              <ol>
                <li>
                  <strong>Delivery Commitment and Confirmation</strong>
                  <br />
                  Sellers must arrange for and confirm their delivery at least one day prior to the
                  committed delivery date. For example, if a seller commits to a 4-day delivery
                  window, they must have arranged for the vehicle by the 3rd day.
                </li>
                <li>
                  <strong>Consequences of Delivery Failure and Penalties</strong>
                  <br />A <b>delivery failure</b> occurs when a seller does not arrange for delivery
                  as committed. Bharee will track all failures for each seller.
                  <ul>
                    <li>
                      <b>First, Second, and Third Failure</b>: For every delivery failure (first,
                      second, or third), the seller will be charged for the{" "}
                      <b>actual transport costs</b>
                      incurred by Bharee, plus a <b>penalty of 5% of the total order value</b>.
                    </li>
                    <li>
                      The seller must ensure the salable material is <b>ready for pickup</b> at the
                      designated warehouse location.
                    </li>
                    <li>
                      The seller must <b>keep ready/upload all necessary documentation</b> for the
                      delivery to Bharee's portal within the specified time. This ensures a seamless
                      handover and enables Bharee to fulfill the delivery without further delays.
                    </li>
                    <li>
                      Bharee will also send a notification to the seller, warning them of the
                      potential for suspension if a third failure occurs.
                    </li>
                    <li>
                      <b>Third Failure</b>: after{" "}
                      <b>three delivery failures within a 60-day period</b>, Bharee will suspend the
                      seller's account without further intimation.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Account Suspension and Reinstatement</strong>
                  <br />
                  An account that is suspended due to delivery failures may be reviewed upon the
                  seller's request. However, the decision to reactivate the account rests{" "}
                  <b>solely with Bharee</b>. Bharee is not obligated to reactivate the account, and
                  any decision will be made on a case-by-case basis.
                </li>
              </ol>
            </p>
          </section>

          <section id="prepaid-payment-instruments">
            <h6>{"Prepaid Payment Instruments"}</h6>
            <br />
            <p>
              {
                "Bharee may, either itself or through third-party service providers, offer prepaid instruments as a payment option for transactions on the Platform to users. Any purchases by Buyers on the Platform using the prepaid instruments shall be governed by the following terms and conditions:"
              }
              <br />
              <ol>
                <li>
                  {
                    "Such prepaid instruments may be used to make payments for the products and / or services purchased on the Platform."
                  }
                </li>
                <li>
                  {
                    "Such prepaid instruments can be redeemed by Buyers by selecting the payment mode as may be provided on the Platform."
                  }
                </li>
                <li>
                  {
                    "Such prepaid instruments cannot be used to purchase other prepaid instruments or gift vouchers."
                  }
                </li>
                <li>
                  {
                    "If the order value exceeds the amount of such prepaid instruments, the balance must be paid by the respective Buyer via Credit Card / Debit Card / Internet Banking. POD or pay later shall not be available as payment option for such transactions"
                  }
                </li>
                <li>
                  {
                    "If the order value is less than the amount of such prepaid instruments, the outstanding balance (after deduction of order value) will reflect as credit balance for such prepaid instruments."
                  }
                </li>
                <li>
                  {
                    "Prepaid instruments and any unused balance of such prepaid instruments shall expire 1 year from the date of their issue."
                  }
                </li>
                <li>{"Prepaid instruments cannot be redeemed for cash."}</li>
                <li>
                  {
                    "Bharee is not responsible if prepaid instruments are lost, stolen, or used without permission."
                  }
                </li>
                <li>
                  {
                    "Buyers can combine and use a maximum of 3 prepaid instruments per order. They can be combined with promotional codes."
                  }
                </li>
                <li>{"Purchases of prepaid instruments are not eligible for cashback offers."}</li>
                <li>
                  {
                    "All Sellers on the Platform will accept this prepaid instrument as a payment instrument."
                  }
                </li>
                <li>
                  {
                    "Bharee will make payments to Sellers whose products and / or services have been purchased by Buyers redeeming Electronic Gift Vouchers (EGV) as per the guidelines issued by the Reserve Bank of India from time to time."
                  }
                </li>
              </ol>
            </p>
          </section>

          <section id="financial-facilities">
            <h6>{"Financial Facilities for Customers"}</h6>
            <br />
            <p>
              {
                "Bharee has operationalized tie-ups with multiple partners for providing financial assistance to Customers for purchasing products on the platform and thereby enhancing the transaction capability of Customers. In pursuance of the same, in the event of the Customers opting for the financial assistance program and you duly receiving such amounts from the partners (on behalf of the Customers), you hereby agree to assign all receivables from the Customer for such transaction. Therefore you hereby agree that without any further action on your part, upon receipt of the amount due from such partners, any and all receivables due from the Customers shall stand assigned in favour of the partner. You hereby authorise Bharee to enter into any documentation on your behalf to complete and perfect the assignment. Upon such assignment, the financing partner shall have all the rights as the Seller may have had in relation to the collection of receivables from the Customer and the Customer shall be required to repay the financing partner directly. The lending partner further reserves the right to assign and transfer such receivables under these terms and conditions to an NBFC / financial institution as it may deem fit."
              }
            </p>

            <h6>{"Charges"}</h6>
            <br />
            <p>
              {
                "Registration on the Platform is free. Bharee does not charge any fee for browsing / registering on the Platform. However, before you list a product or service for sale through the Platform, we request you to review our fee policy, which is hereby incorporated by reference into this ToU. Bharee reserves the right to change its fee policy from time to time. In particular, Bharee may, at its sole discretion, introduce new services and modify some or all of the existing services offered on the Platform. In such an event, Bharee reserves the right to introduce fees for the new services offered or amend / introduce fees for existing services, as the case may be. Changes to the fee policy shall be posted on the Platform and such changes shall automatically become effective immediately after they are posted on the Platform. Unless otherwise stated, all fees shall be quoted in Indian Rupees (INR) and payable to Bharee. You shall be solely responsible for compliance with all applicable laws for making payments to Bharee. You hereby agree that Bharee shall have the right to set off any amounts due and payable by You to Bharee against any payments due from Bharee to You."
              }
            </p>
          </section>

          <section id="gst-taxes">
            <h6>{"GST / Taxes"}</h6>
            <br />
            <p>
              {
                "You are responsible for paying all fees associated with the use of the Platform and charges collected in respect of such usage. You agree to bear any and all applicable taxes, charges, cesses levied thereon (including CGST+SGST / IGST / CGST + UGST and GST cess as may be applicable to the transaction)."
              }
              <br />
              <ol>
                <li>
                  {
                    "A Seller agrees that Bharee may offer to provide Express Remittance to eligible Sellers as per payments settlement policy. Express Remittance shall be subject to RBI Intermediary Guidelines and arrangements / directions of the nodal bank. Bharee, at its sole discretion, may make such an offer to eligible Sellers and the same shall not be construed as a right but only as a privilege. Eligible Sellers understand that Bharee reserves the right to withdraw Express Remittance at any time for any violation of the ToU or Bharee’s policies and / or failure by the eligible Sellers to maintain or comply with the parameters as may be decided by Bharee from time to time"
                  }
                </li>
                <li>
                  {
                    "nvoice generation: A Seller expressly agrees that issuing correct and complete invoice is the sole and primary responsibility of a Seller. We will assist you with this process by generating an invoice on your behalf. For us to generate these invoices, we would need a digital image of your signature which will be affixed on the invoice. The invoice shall then be generated and sent to the Seller. The Seller shall be required to physically sign the invoice, print the invoice and affix the same on the consignment. The invoice generated by Bharee shall be affixed by the Seller on the consignment. Notwithstanding anything else contained in these terms of use, the Seller shall be solely liable for any liability which may be imposed by taxation authorities for any discrepancy in the invoices."
                  }
                  <span>
                    {
                      "A Seller expressly agrees that issuing the correct and complete invoice is the sole and primary responsibility of a Seller."
                    }
                  </span>
                </li>
                <li>
                  {
                    "In case of any chargebacks levied by the bank, Bharee shall have the right to deduct such chargebacks from Seller remittances, present and future, and a Seller’s only remedy will be to discuss and resolve the same with the bank. A Seller hereby agrees to extend full cooperation in resolving the chargeback disputes raised by a Buyer through the bank and shall provide necessary documentation regarding the transaction to the complete satisfaction of the bank. In case the chargeback is ruled against a Seller, Bharee shall be entitled and authorised to recover the same from the Seller to its fullest extent and the bank’s decision shall be final and binding in this regard. In the event Bharee has made any excess payment to the Seller inadvertently, such excess payments shall be set-off from any future payments payable by Bharee to the Seller."
                  }
                </li>
                <li>
                  {
                    "Bharee may delay notifying the payment confirmation, i.e. informing the Seller to dispatch if Bharee deems suspicious or a Buyer conducts high transaction volumes to ensure safety of the transaction and transaction price. In addition, Bharee may hold transaction prices and not inform Sellers to dispatch or remit transaction prices to law enforcement officials (instead of refunding the same to a Buyer) at the request of law enforcement officials or in the event of a Buyer being engaged in any form of illegal activity."
                  }
                </li>
                <li>
                  {
                    "Sellers acknowledge that Bharee will not be liable for any damages, interests, claims etc. resulting from not processing a transaction / transaction price or any delay in processing a transaction / transaction price that is beyond the control of Bharee."
                  }
                </li>
                <li>
                  {
                    "Bharee shall make payments into the bank account provided by a Seller during the Seller registration process. Once Bharee has made payments into such a bank account number, Bharee shall be discharged of any / all liabilities towards the Seller and the Seller shall not be eligible for any claims whatsoever."
                  }
                </li>
              </ol>
            </p>
          </section>

          <section id="compliance-laws">
            <h6>{"Compliance with Laws"}</h6>
            <br />
            <p>
              <ol>
                <li>
                  {
                    "Seller acknowledges and undertakes the compliance with all applicable laws and also will sign the declarations captured in this ToU."
                  }
                </li>
                <li>
                  {
                    "n the event of sale of jewellery, the Seller shall provide a hallmark certificate (in accordance with applicable laws) along with the product at the time of delivery. Further, it shall be sole responsibility of the Seller to comply with hallmarking or other similar provisions applicable for the sale of jewellery and Bharee shall not be liable whatsoever for any non-compliance in this regard."
                  }
                </li>
                <li>
                  {
                    "In the event of sale of jewellery, Seller shall ensure conduct of Buyer KYC in accordance with the prevention of anti-money laundering laws and other applicable laws. Bharee"
                  }
                </li>
                <li>{"ereby disclaims any responsibility for conducting Buyer KYC."}</li>
                <li>
                  {
                    "Seller will fully comply with all applicable laws and regulations including but not limited to anti-money laundering (including know your customer and customer due-diligence) and sanctions (economic and trade) enforced by the United Nations, the Republic of India, U.S. Department of Treasury’s Office of Foreign Assets Control (OFAC). Neither party will engage in a transaction pursuant to this agreement that will cause the other party to violate such laws and regulations"
                  }
                </li>
                <li>
                  {
                    "Seller shall ensure that no products are sourced or used in the manufacturing or in the provision of services which originate wholly or in part, from any of the prohibited countries stated in the ‘OFAC Regulations and Other Applicable Sanctions Regulations’. The extant Trade Compliance Policy Statement is available at the Seller Learning Centre."
                  }
                </li>
                <li>
                  {
                    'If and to the extent that you collect, access, use, store, record, or otherwise process (collectively “Process”) any personally identified or identifiable information such as name, age, gender, email address, physical address, phone number, in any form that can be linked to a specific individual (“Personal Information”) received by you from or on behalf of Bharee (or any Bharee group company) employees, contractors, users, partners, or other third parties or otherwise obtained in connection with performing your obligations under this ToU (“Bharee’s Personal Information"), you agree to:'
                  }
                  <br />
                  <ul>
                    <li>
                      {
                        "comply with applicable data protection laws, rules and regulations governing the collection, use, protection, breach notification, retention, disclosure of Personal Information including but not limited to Information Technology Act, 2000 and the Information Technology (Reasonable Security practices and procedures and sensitive personal data or information) Rules, 2011 (“Applicable Data Protection Law”), including any requirements applicable to storage or cross-border transfer of Personal Information outside India;"
                      }
                    </li>
                    <li>
                      {
                        "keep and maintain all Bharee’s Personal Information in strict confidence and the obligation to protect Personal Information shall survive in perpetuity; and"
                      }
                    </li>
                    <li>
                      {
                        "process Bharee’s Personal Information solely to fulfil Your obligations under this ToU and not sell, rent, trade, lease, use for its own advertisement or marketing purposes, or otherwise make an unauthorised disclosure of Bharee’s Personal Information to any third party."
                      }
                    </li>
                  </ul>
                </li>
                <li>
                  {
                    "f and to the extent that you provide yours or others’ Personal Information to Bharee for processing, you warrant that such Personal Information was collected lawfully, and there is no restriction on you under the Applicable Data Protection Law, from providing such Personal Information to Bharee or any processing by Bharee under this ToU. We will only use information provided by you in accordance with this ToU and our Privacy Policy available at www.Seller.Bharee.com."
                  }
                </li>
                <li>
                  {
                    "You undertake sole and exclusive responsibility to ensure that the products you want to list on Bharee.com for Sales are permissible for such a Sale and are not prohibited or restricted per one or many conditions imposed by the extant laws of the land, Bharee’s Prohibited and Restricted Items Policy, or other Bharee policies / Indian Laws listed in Seller Learning Portal."
                  }
                </li>
                <li>
                  {
                    "Products must adhere to the Legal Metrology laws and Indian Labelling requirements by ensuring that the indicated weights and measurement indicated in the products and / or its components are commensurate with the mandatory and legal requirements of the same which make the product and / or components accurate, authentic and secure for consumption / utilisation by the Customer. Bharee does not assume any responsibility for the proceedings undertaken by an aggrieved Customer / Consumer against the Seller in the event of a non-adherence. However, in the event of a complaint from a Consumer / Customer, the Seller is obligated to answer queries on the non-adherence to the Legal Metrology Laws, failing which Bharee can temporarily / indefinitely suspend / terminate / block / with-hold your account at its own discretion."
                  }
                </li>
                <li>
                  {
                    "Compliances under The Consumer Protection (E-commerce) Rules, 2020 as amended and if substituted from time to time:"
                  }
                  <br />
                  <ol type="a">
                    <li>
                      {
                        "You should not mislead and misguide the Consumer by posting false reviews for your own products / service's quality and features pretending as Consumer on the Bharee Platform."
                      }
                    </li>
                    <li>
                      {
                        "If in case your products / services are defective, deficient, adulterated or spurious, or if the products or services are not of the features as advertised or as agreed to or delivered late from the stated delivery schedule. You shall provide benefits of Refund, Return / Replacement, Exchange, Warranty and Guarantee, Withdrawal and Cancellation for the products / services listed on the Bharee Platform."
                      }
                    </li>
                    <li>
                      {"You agree and undertake to comply with:"}
                      <br />
                      <ul>
                        <li>
                          {
                            "To register yourself with Bharee Private Limited for selling your products / services on Bharee Platform;"
                          }
                        </li>
                        <li>
                          {
                            "To form a Consumer Grievance Redressal Mechanism to resolve the consumer disputes whenever referred by Bharee Platform;"
                          }
                        </li>
                        <li>
                          {
                            "The products / services offered on the Bharee Platform are consistent with actual quality and features of the products / services as shown on Bharee Platform;"
                          }
                        </li>
                        <li>
                          {
                            "To display your all details such as your company's / Firm’s name, geographic address, customer care details, consumer's review for the product / services listed & other info, if any;"
                          }
                        </li>
                      </ul>
                    </li>
                    <li>
                      {"You shall be responsible to display your:"}
                      <br />
                      <ul>
                        <li>
                          {
                            "Products / services details on the Bharee Platform, which are required to be displayed as per applicable laws;"
                          }
                        </li>
                        <li>
                          {
                            "Total price of products / services & its breakup with all required charges (delivery charges / postal charges / handling / conveyance charges and applicable taxes);"
                          }
                        </li>
                        <li>
                          {
                            "Manufacturing / packed date, Expiry date of products wherever applicable by law;"
                          }
                        </li>
                        <li>
                          {
                            "Required details of products / services including Country Of Origin to enable the consumer to make the right decision;"
                          }
                        </li>
                      </ul>
                    </li>
                    <li>{"To appoint your Grievance Officers;"}</li>
                    <li>
                      {
                        "In case your products are imported it may be by you or from someone else, you need to provide the details such as Name and complete address as “Imported by”;"
                      }
                    </li>
                    <li>
                      {
                        "You shall ensure the authenticity or genuineness of your products / services;"
                      }
                    </li>
                    <li>
                      {
                        "You shall provide updates on shipment and delivery of products / services that are shipped from your premises;"
                      }
                    </li>
                    <li>
                      {
                        "You shall provide the Guarantees or Warranties for your products / services, if applicable."
                      }
                    </li>
                    <li>
                      {
                        "Compliances under The Legal Metrology (Packaged Commodities) Rules 2011 as amended and if substituted from time to time"
                      }
                      <br />
                      <ul>
                        <li>
                          {
                            "Your products / services listed on Bharee Platform has to comply with the Rule 6 (10) of the LM (PC) Rules, 2011;"
                          }
                        </li>
                        <li>
                          {
                            "You shall be responsible for displaying all the product’s label declarations on the Bharee Platform as required under Rule 6 (1) of LM (PC) Rules for the consumer’s review;"
                          }
                        </li>
                        <li>
                          {
                            "Any non compliance by you in regards to your product / services, which get listed on the Bharee Platform, you shall be solely responsible and liable for the legal repercussions;"
                          }
                        </li>
                        <li>
                          {
                            "You shall indemnify and shall keep indemnified Bharee Private Limited for all the direct and indirect losses, damages, fines, penalties, etc., incurred / suffered by the Bharee Private Limited and or as and when imposed by any government offices / authorities due to commission of unlawful act or non commission of lawful act, negligence act by you in regards to your products / services listed on the Bharee Platform."
                          }
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
              </ol>
            </p>
          </section>

          <section id="anti-corruption">
            <h6>{"Anti-Corruption"}</h6>
            <br />
            <p>
              <ol>
                <li>
                  <span>{"Compliance with Law and Policy: "}</span>
                  {
                    "Seller agrees that its performance under this Agreement will be in full compliance with the Company’s Global Anti-Corruption Policy (the “Policy”, available at https://Bhareeethics.com and all applicable anti-corruption laws and regulations, including but not limited to the U.S. Foreign Corrupt Practices Act and the UK Bribery Act. Seller and the Company agree that in their performance under this Agreement, they will not directly or indirectly offer, promise, give, or authorise the giving of anything of value, or offer, promise, make, or authorise the making of any bribe, facilitation payment or other improper or unlawful payment to any government official, political party, or candidate for public office in order to obtain or retain business, gain any unfair advantage, or influence any act or decision of a government official."
                  }
                </li>
                <li>
                  <span>{"Certification of Compliance: "}</span>
                  {
                    "Seller agrees to certify its compliance with the applicable anti-corruption laws and regulations by executing a form supplied by the Company for this purpose, either annually or when otherwise requested by the Company."
                  }
                </li>
                <li>
                  <span>{"Right to Audit and Obligation to Cooperate:"}</span>
                  {
                    "Seller shall keep accurate books, records, and accounts with sufficient detail as to clearly reflect its transactions and disposition of its resources or assets in connection with this ToU. Seller agrees the Company has the right to audit such transactions at any time and upon reasonable notice. Seller agrees to (1) provide assistance and cooperation in any investigations involving the Company and Seller, and (2) submit to due diligence re-screening when requested by the Company."
                  }
                </li>
                <li>
                  <span>{"Training:"}</span>
                  {
                    "Seller agrees its employees, affiliates, and other representatives responsible for its performance under this ToU will participate in the Company’s anti-corruption training, if requested by the Company."
                  }
                </li>
                <li>
                  <span>{"Subcontractors:"}</span>
                  {
                    "Seller must obtain prior written authorization from the Company before Seller engages any subcontractor to perform any services under this ToU requiring interaction with any government Seller or government official on the Company’s behalf."
                  }
                </li>
                <li>
                  <span>{"Right to Terminate:"}</span>
                  {
                    " If the Company reasonably suspects that the Seller has engaged in conduct violating the Policy, or any applicable anti-corruption laws or regulations, the Company may immediately suspend payment pending the issue’s resolution. If the Company determines that the Seller violated the Policy, or any applicable anti-corruption law or regulations, the Company may terminate the ToU. The Company may also suspend payment and suspend or terminate the ToU if the Seller does not comply with the ongoing anti-corruption compliance obligations set forth in this ToU or if Seller does not successfully complete due diligence re-screening."
                  }
                </li>
                <li>
                  <span>{"Form of Payment:"}</span>
                  {
                    "The Parties agree all payments made by the Company to the Seller pursuant to this ToU shall be made only after receipt by the Company of an invoice detailing the products or services for which Seller is seeking payment. All payments under this ToU shall: (i) be made solely by check or wire transfer for the benefit of, and to the account of, Seller and not to any individual employee or representative of Seller; (ii) be denominated in functional currency; and (iii) not be in cash or bearer instruments."
                  }
                </li>
                <li>
                  <span>{"Obligation to Provide Information: "}</span>
                  {
                    "If for any reason, the Seller proposes to materially change ownership or management or its current shareholders or partners transfer control of the Seller to a third party or a third party assumes control of the Seller, the Seller must notify the Company within thirty (30) days of such change in writing. In such cases, Seller may be resubmitted through the Company’s due diligence and approval procedure for third-party intermediaries. The Seller agrees to provide timely information to the Company regarding any changes to the representations made in this ToU."
                  }
                </li>
                <li>
                  <span>{"No Government interaction: "}</span>
                  {
                    "Seller agrees that neither Seller nor any of its employees, agents and representatives, and any persons associated with Seller are authorised to engage or interact with any government Seller or official for or on behalf of either Bharee, directly or indirectly, in any transaction or business activity for any purpose, including but not limited to obtaining a permit, licence or other type of authorization, whether at a local, regional or national level. In the event that any form of interaction with a government entity or government official is required in relation to Seller’s engagement, directly and / or indirectly, with Bharee, the Seller shall obtain prior written authorization from Bharee before proceeding with the engagement or interaction."
                  }
                </li>
              </ol>
            </p>
          </section>

          <section id="product-description">
            <h6>{"Product Description"}</h6>
            <br />
            <p>
              {
                "Bharee does not warrant that product description or other content on the Platform is accurate, complete, reliable, current, or error-free and assumes no liability in this regard."
              }
            </p>
          </section>

          <section id="audits">
            <h6>{"Audits"}</h6>
            <br />
            <p>
              {
                "Bharee shall have the right to inspect and audit Seller’s records and premises / place of business through itself or through Bharee approved third party testing agencies. Cost of such an audit shall solely be borne by Bharee unless the audit reflects discrepancy in Seller accounts / non-compliance with Bharee’s Seller policies, in which case the cost of audit shall be borne by the Seller."
              }
            </p>

            <h6>{"Breach"}</h6>
            <br />
            <p>
              {
                "Without limiting other remedies, we may limit your activity, immediately remove your information, warn other users of your actions immediately, temporarily / indefinitely suspend / terminate / block your account and / or refuse you access to the Platform, or put your account on hold, in the event of, including but not limited to, the following:"
              }
              <br />
              <ol>
                <li>
                  {
                    "if you breach the ToU, privacy policy or other policies such as Prohibited & Restricted Item Policy, etc.;"
                  }
                </li>
                <li>{"if we are unable to verify or authenticate any information you provide;"}</li>
                <li>
                  {
                    "if it is believed that your actions may cause legal liability for you, other users, or us; or"
                  }
                </li>
                <li>
                  {
                    "if you do not produce the legal requirement documents such as the documents required for product sales in the Drugs and Cosmetics category, the BIS licence documents, the Brand Authorisation letter, or a Trademark registration proof, as may be required by the Bharee Authorities."
                  }
                </li>
              </ol>
              {
                "We may at any time, at our sole discretion, reinstate suspended Sellers. A Seller that has been suspended or blocked may not register or attempt to register with us or use the Platform (through itself or any other entity or legal form) in any manner whatsoever until such time that such a Seller is reinstated by us. Notwithstanding the foregoing, if you breach the ToU or other rules and policies, we reserve the right to recover any amounts due and owed by you to us and take strict legal action, including but not limited to a referral to the appropriate police or other authorities for initiating criminal or other proceedings against you."
              }
            </p>

            <h6>{"Indemnity"}</h6>
            <br />
            <p>
              {
                "You shall indemnify and hold harmless Bharee its owner, licensee, affiliates, subsidiaries, group companies (as applicable) and their respective officers, directors, agents, and employees from any claim, demand, or actions including reasonable attorneys' fees made by any third party or penalty imposed due to or arising out of your breach of the ToU, privacy policy and other policies or your violation of any law, rules, regulations or the rights (including infringement of intellectual property rights) of a third party."
              }
            </p>

            <h6>{"Trademark Complaint"}</h6>
            <br />
            <p>
              {
                "Bharee respects the intellectual property of others. In case you feel that your trademark has been infringed, you can write to Bharee at care@bharee.com."
              }
            </p>

            <h6>{"Copyright Complaint"}</h6>
            <br />
            <p>
              {
                "Bharee respects the intellectual property of others. In case you feel that your work has been copied in any way that constitutes copyright infringement you can write to Bharee at care@bharee.com or raise an incident from your Seller dashboard."
              }
            </p>

            <h6>{"Trademark, Copyright and Restriction"}</h6>
            <br />
            <p>
              {
                "The Website is controlled and operated by Bharee and products are sold by respective registered Sellers. All material on the Platform, including images, illustrations, audio clips, and video clips, are protected by copyrights, trademarks and other intellectual property rights. You must not copy, reproduce, republish, upload, post, transmit, or distribute Bharee’s or other Sellers’ material in any way, including by email or other electronic means and whether, directly or indirectly, you must not assist any other person to do so. Without the prior written consent of the owner, modification or use of the material on any other website / networked computer environment or for any purpose other than personal, non-commercial use is a violation of the copyrights, trademarks, and other proprietary rights is prohibited. Any use for which you receive any remuneration, whether money or otherwise, is a commercial use for the purposes of this clause."
              }
            </p>

            <h6>{"Limitation of Liability"}</h6>
            <br />
            <p>
              {
                "IN NO EVENT SHALL BHAREE BE LIABLE FOR ANY SPECIAL, INCIDENTAL, INDIRECT, OR CONSEQUENTIAL DAMAGES OF ANY KIND IN CONNECTION WITH THE ToU, EVEN IF BHAREE HAS BEEN INFORMED IN ADVANCE OF THE POSSIBILITY OF SUCH DAMAGES."
              }
            </p>

            <h6>{"Applicable Law"}</h6>
            <br />
            <p>
              {
                "Unless otherwise specified, the material on the Website is presented solely for the purpose of sale in India. Bharee makes no representation that the material on the Website is appropriate or available for use in other locations / countries other than India. Those who choose to access the Website from other locations / countries other than India do so on their own initiative and Bharee is not responsible for supply of products / refund for the products ordered from other locations / countries other than India and compliance with local laws, if and to the extent local laws are applicable."
              }
            </p>

            <h6>{"Seller Declarations"}</h6>
            <br />
            <p>
              {
                "We, hereby represent, warrant, covenant and undertake to ensure that we have obtained and shall continue to maintain in force all licences, registrations, permissions, authorisations, certifications, compliances and permits needed to manufacture, import, store, display, exhibit for sale, advertise, distribute, market, supply and sell the respective products (“Products”) on the application / app, website of Bharee Private Limited (Bharee) under applicable laws, legislations, notifications, notice, circulars, orders, directions, clarifications, advisories, etc. (now in effect or introduced in future) as amended from time to time, including but not limited to the following:"
              }
              <br />
              {"S.N Segment & Declaration By Sellers"}
            </p>

            <p>
              <ol>
                <li>
                  <span>{"BIS Certification : "}</span>
                  {
                    'The Bureau of India Standards Act 1986 ("BIS Act”), Electronics and Information Technology Goods (Requirements for Compulsory Registration) Order 2012, all applicable Quality Control Orders issued under the BIS Act, ISI Mark Scheme, Energy Conservation Act 2001 & rules and regulations made thereunder and all applicable legislations under BIS CRS / BIS - ISI BEE Product Safety and Standards Regulations, in each case, as amended from time to time. We have obtained and shall continue to maintain in force, all certificates and authorisations needed under applicable laws for lawful sale of the Products.'
                  }
                </li>
                <li>
                  <span>{"Products containing Plastic : "}</span>
                  {
                    "The Plastic Waste Management Rules, 2016, as amended from time to time and the Environment (Protection) Act, 1986, as amended from time to time. We have obtained and shall continue to maintain in force all certificates and authorisations, provisional certificates wherever required under applicable laws for lawful sale of the Products."
                  }
                </li>
                <li>
                  <span>{"Food Products :"}</span>
                  {
                    "The Food Safety and Standards Act, 2006, Food Safety and Standards (licensing and registration of food business), Regulations, 2011 including all applicable regulations made thereunder, in each case, as amended from time to time. We shall ensure the information provided by me on the website or mobile app regarding product name, product description and its applicable attribute is true in nature. We further represent and warrant that:"
                  }
                  <br />
                  <ul>
                    <li>
                      {
                        "The FSSAI licence number granted to me by the Food Safety and Standards Authority of India (“FSSAI Licence”) is indicated by me on the Bharee platform."
                      }
                    </li>
                    <li>{"I shall display the FSSAI Licence/ Registration on the Platform."}</li>
                    <li>
                      {
                        "Legible and clear picture of the “principal display panel” of pre-packed food shall be made available by me for viewing by Customers on the platform, if applicable to the Products, except batch number/lot number, best before, expiry date, date of manufacturing packing and MRP;"
                      }
                    </li>
                    <li>
                      {
                        "Any food article delivered to the consumer by me or on my behalf shall have a shelf life of 30 percent or 45 days before expiry at the time of delivery to the consumer, or as amended under applicable laws from time to time."
                      }
                    </li>
                    <li>
                      {
                        "All mandatory food information mentioned in the Food Safety and Standards Act, 2006, and the rules and regulations made thereunder shall be made available to Customers for viewing without charging supplementary costs and shall be made available before the purchase is concluded."
                      }
                    </li>
                    <li>
                      {
                        "No misleading information/false claims to the product or misleading images of food products are/shall be made available by me;"
                      }
                    </li>
                    <li>
                      {
                        "We shall ensure that all basic hygiene and sanitary practices mentioned in the Schedule 4 of Food Safety and Standards (Licensing and Registration of Food Businesses), Regulations 2011 are complied with."
                      }
                    </li>
                    <li>
                      {
                        "We shall comply with all applicable provisions of the, Food Safety and Standards (Packaging) Regulations, 2018 & Food Safety and Standards (Labelling and Display) Regulations, 2020, as amended from time to time."
                      }
                    </li>
                    <li>
                      {
                        "We shall ensure that every package of food distributed, marketed, supplied or sold by me shall carry the following information on the label, as per applicable laws, products categories and specifically the Food Safety and Standards (Packaging) Regulations, 2018 & Food Safety and Standards (Labelling and Display) Regulations, 2020,, namely as applicable:"
                      }
                    </li>
                    <li>{"The Name of Food;"}</li>
                    <li>{"List of Ingredients;"}</li>
                    <li>{"Nutritional information;"}</li>
                    <li>{"Declaration regarding Veg or Non veg;"}</li>
                    <li>{"Declaration regarding Food Additives;"}</li>
                    <li>{"Declaration regarding allergens;"}</li>
                    <li>
                      {
                        "Name and complete address of the manufacturer with FSSAI licence number as applicable;"
                      }
                    </li>
                    <li>
                      {
                        "The package of food shall carry the name and complete address of the importer in India where an article of food is imported into India;"
                      }
                    </li>
                    <li>{"Net quantity;"}</li>
                    <li>{"Lot/Code/Batch identification;"}</li>
                    <li>{"Date of manufacture or packing;"}</li>
                    <li>{"Best Before and Use by Date;"}</li>
                    <li>{"Country of origin for imported food;"}</li>
                    <li>{"Instructions for use;"}</li>
                    <li>{"Customer care details;"}</li>
                    <li>{"Retail sale price."}</li>
                    <li>
                      {
                        "We shall comply with all applicable provisions of food safety audits for high-risk food categories under the Food safety and standard (Food safety auditing) regulation, 2018 as applicable to products."
                      }
                    </li>
                    <li>
                      {
                        "We shall ensure all food must be supplied/delivered in a way that ensures its fitness for human consumption. As appropriate to the product, the temperature and other necessary conditions shall be maintained as applicable to products. We hereby undertake to ensure that for all times during which the retail licence is not applicable as per the applicable laws, the Seller shall furnish the manufacturing licence to Bharee as per all applicable laws as amended from time to time."
                      }
                    </li>
                  </ul>
                </li>
              </ol>
            </p>

            <p>
              {
                "Further, we hereby represent, warrant, covenant and undertake that we will adhere to the requirements laid down under the following regulations for all the products sold on Bharee:"
              }
              <br />
              <br />

              {
                " The Legal Metrology Act, 2009, the Legal Metrology (Packaged Commodities) Rules, 2011 and the Legal Metrology (Packaged Commodities) Amendment Rules, 2017 and 2021, Extensions and FAQs 2022, as amended from time to time and have obtained and shall continue to maintain in force all certificates and authorisations needed under applicable laws for lawful sale of the products."
              }
              <br />
              <br />

              {
                "The Consumer Protection (E-commerce) Rules, 2020, as amended from time to time including but not limited to ensuring that descriptions, images and other content pertaining goods or services on the platform is accurate and corresponds directly with the appearance, nature, quality, purpose and other general features of such goods or services."
              }
              <br />
              <br />

              {
                "Foreign Exchange Management Act, 1999, and the rules made and notifications issued thereunder and the Exchange Control Manual as may be issued by Reserve Bank of India from time to time, Customs Act, Information and Technology Act, 2000, as amended by the Information Technology (Amendment) Act, 2008, Prevention of Money Laundering Act, 2002, and the rules made there under, Foreign Contribution Regulation Act, 1976, and the rules made there under, Income Tax Act, 1961, and the rules made there under, Export Import Policy of Government of India, applicable to them respectively for using Payment Facility."
              }
              <br />
              <br />

              {
                "We also understand and confirm that we will not be listing any products that are sourced or used in the manufacturing or in the provision of services which originate wholly or in part, from any of the prohibited countries stated in the ‘OFAC Regulations and Other Applicable Sanctions Regulations’, which includes Iran, Cuba, North Korea (Democratic People’s Republic of Korea), Syria, Ukraine (limited to Crimea, Donetsk, Luhansk regions) and we are in compliance with all applicable laws as amended from time to time."
              }
              <br />
              <br />

              {
                " We acknowledge that Bharee has relied on this undertaking and that any breach thereof will cause irreparable harm to Bharee and we unconditionally undertake to make Bharee good and hold it harmless against any breach thereof immediately upon request, from time to time, without protest or demur. Further, we shall immediately notify Bharee, in writing, upon the lapse of any necessary certificates or authorisations and/or in case of receipt of any order, demand, warrant or document or any regulatory action with respect to such certificates / authorisations."
              }
              <br />
              <br />

              {
                "In the event the relevant authority demands the certificate to Bharee, we shall produce a copy of the said certificate at the earliest. Any delay in producing the certificate / absence of a certificate that leads to any loss / penalty to Bharee shall be recovered from the Seller providing the declaration within 7 days from such demand."
              }
              <br />
              <br />

              {
                "We acknowledge and agree that Bharee shall be permitted to assign or otherwise furnish this undertaking to any authority or person."
              }
              <br />
              <br />

              {
                "The courts in Pune shall have exclusive jurisdiction on any matters set forth herein and this will be governed by the laws of the Republic of India."
              }
              <br />
              <br />

              {
                "Any notice given by Bharee to us through email registered with them or at our address registered with them shall be deemed received one (1) business day after an email is sent and in case of post, three (3) business days, and, if hand delivered, on delivery. We undertake to keep Bharee updated with any changes to our registered information."
              }
              <br />
              <br />
              <span>
                {
                  "By agreeing to the Terms of Use captured herein, we acknowledge that the declarations stated above are true and accurate and we agree to be bound by it to the extent applicable to the Product sold by us on the Platform."
                }
              </span>
            </p>
          </section>

          <h6>{"Contact Us"}</h6>
          <br />
          <p>
            {
              "For queries / concerns, excluding queries related to trademark and copyright infringement, please raise an incident from your Seller dashboard."
            }
            <br />
            <span>{"Grievance Officer"}</span>
            <br />
            {
              "In accordance with the IT Act, 2000, and the rules thereunder, the name and contact details of the grievance officer are provided below:"
            }
            <br />
            <br />

            <sapn>{"Bharee Beverages Ecom Pvt. Ltd."}</sapn>
            <br />
            {"Office No-219 & 220, Jai Ganesh Vision Akurdi Pune-411035 Maharashtra, India"}
            <br />
            {"Email: support@bharee.com"}
          </p>
        </Row>
      </div>
    </section>
  );
};

export default Terms;
